import { ComponentStyleConfig } from '@chakra-ui/react';

const Select: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
  },
  variants: {
    primary: {
      field: {
        bg: 'input-bg',
      },
    },
  },
};

export default Select;
